import React from 'react';
import { Router } from 'react-router-dom';
import ArtContestAppLayoutContainer from '../containers/ArtContestAppLayoutContainer';
import history from '../history';

const ArtContestAppRouter = () => (
    <Router history={history}>
        <ArtContestAppLayoutContainer />
    </Router>
);

export default ArtContestAppRouter;